import { isNullish } from '../utils'
import { DataRow } from '../types/components/data-rendering'

export interface UseFilterReturnInterface {
  filterData: (data: DataRow[], filter: string | null) => DataRow[]
}

export function useFilter(): UseFilterReturnInterface {
  const filterData = (data: DataRow[], filter: string | null): DataRow[] => {
    if (filter === null) {
      return data
    } else {
      const acc: DataRow[] = []
      if (!isNullish(data)) {
        for (let index = 0; index < data.length; index++) {
          const row = data[index]
          if (JSON.stringify(Object.values(row)).toUpperCase().indexOf(filter.toUpperCase()) > -1) {
            acc.push(row)
          }
        }
      }
      return acc
    }
  }

  return {
    filterData,
  }
}
